import React from 'react';
import { withRouter } from 'react-router';
import '../statics/stylesheet.css';
import R from 'ramda';
import Modal from '../components/Modal/modal';
import Searchsku from '../components/Modal/searchsku';
import SearchskuTires from '../components/Modal/searchskutires';
import WinterPackage from './winterpackage';
import SeosonalSwap from './SeasonalSwap';
import SeasonalSwapReschedule from './SeasonalSwapReschedule';
import Gallery from './Gallery';
import MarketplaceItems from './MarketplaceItems';

class SearchBy extends React.Component {
  constructor(props) {
    if (window.localStorage.getItem('performance tire')) {
      localStorage.removeItem('performance tire');
    }
    if (window.localStorage.getItem('winter wheels')) {
      localStorage.removeItem('winter wheels');
    }
    super(props);

    this.state = {
      loading: false,
      year: window.localStorage.getItem('carYear') === null ? undefined : window.localStorage.getItem('carYear'),
      make: window.localStorage.getItem('carMake') === null ? undefined : window.localStorage.getItem('carMake'),
      model: window.localStorage.getItem('carModel') === null ? undefined : window.localStorage.getItem('carModel')
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  onChangeDropdownSelected = (event, type) => {
    event.preventDefault();
    const value = event.target.value;
    const year = type === 'year' ? value : this.state.year;
    const make = type === 'make' ? value : type === 'model' ? this.state.make : undefined;
    const model = type === 'model' ? value : undefined;

    year !== undefined ? window.localStorage.setItem('carYear', year) : window.localStorage.removeItem('carYear');
    make !== undefined ? window.localStorage.setItem('carMake', make) : window.localStorage.removeItem('carMake');
    model !== undefined ? window.localStorage.setItem('carModel', model) : window.localStorage.removeItem('carModel');

    this.fillDropDowns(year, make, model);
  }

  componentWillMount() {
    // For wheele size
    const a = [];
    const dataTire = require('../utils/tiresize.json');
    dataTire.wheel_sizes.map((r, id) =>
      a.push(r.name)
    );
    const wheelSize = a.sort();

    // For Brands of wheels
    const b = [];
    const dataWheelsBrands = require('../utils/wheelsFilter.json');

    dataWheelsBrands.Brands.map((r, id) =>
      b.push(r.name)
    );

    this.setState({
      wheelSizes: wheelSize,
      wheelBrands: b
    });
    this.fillDropDowns(this.state.year, this.state.make);
  }

  fillDropDowns = (year, make, model) => {
    this.setState({ year, make, model });
  
    const rawData = localStorage.getItem('vehicles');
    if (!rawData) {
      console.warn("No 'vehicles' data in localStorage.");
      return;
    }
  
    let data = {};
    try {
      data = JSON.parse(rawData);
    } catch (e) {
      console.error("Failed to parse 'vehicles' JSON from localStorage:", e);
      return;
    }
  
    if (!data || typeof data !== 'object' || Object.keys(data).length === 0) {
      console.warn("Invalid or empty 'vehicles' data.");
      return;
    }
   
    if (!data[year]) {
      year = Object.keys(data)[0];
    }
    if (!data[year][make]) {
      make = Object.keys(data[year])[0];
    }
  
    const sortedMakes = year !== undefined ? Object.keys(data[year]).sort() : undefined;
    const sortedModels = year !== undefined && make !== undefined ? data[year][make].sort() : undefined;
  
    this.setState({
      years: Object.keys(data).reverse(),
      makes: sortedMakes,
      models: sortedModels
    });
  }

  getOptionsListFor = (optionType) => {
    const getOptions = (option) => <option key={option} value={option}>{option}</option>;
    return R.map(getOptions)(this.state[optionType]);
  }

  getSearchOptionsForCategory = (category) => {
    const { year, make, model } = this.state;
    const yearValue = year === undefined ? 'Year' : window.localStorage.getItem('carYear');
    const makeValue = make === undefined ? 'Make' : window.localStorage.getItem('carMake');
    const modelValue = model === undefined ? 'Model' : window.localStorage.getItem('carModel');

    if (category === 'in-store specials') {
      return (
        <div>
            <h2 className='in-store-special' style={{ color: '#bd1212', textAlign: 'center', fontWeight: '700', marginTop: '0px', paddingTop: '175px' }}>IN-STORE SPECIALS
            </h2>
           <div className='content-divLength shop_wheel_section' style={{ paddingTop: '2px' }}>
                    <div>
                       <div>
                         {this.renderwinterpackage('Vehicle', category)}
                       </div>
                    </div>
           </div>
         </div>
      );
    }

        if (category === 'vehicle_gallery') {
      return (
        <div >
            <h2 className='in-store-special' style={{ color: '#bd1212', textAlign: 'center', fontWeight: '700', marginTop: '0px', paddingTop: '175px', backgroundColor: '#000000f8', marginBottom: '0px' }}>
            </h2>
           <div className='content-divLength shop_wheel_section' style={{ paddingTop: '0px', background: 'linear-gradient(358deg, #3f0303 0%, #000000f8 100%)' }}>
                    <div>
                       <div>
                         <Gallery/>
                       </div>
                    </div>
           </div>
         </div>
      );
    }
    if (category === 'Marketplace') {
      return (
        <div >
            <h2 className='in-store-special' style={{ color: '#bd1212', textAlign: 'center', fontWeight: '700', marginTop: '0px', paddingTop: '175px', backgroundColor: '#000000f8', marginBottom: '0px' }}>
            </h2>
           <div className='content-divLength shop_wheel_section' style={{ paddingTop: '0px', background: 'linear-gradient(358deg, #3f0303 0%, #000000f8 100%)' }}>
                    <div>
        <div>
          <MarketplaceItems />
        </div>
                   </div>
           </div>
         </div>
      );
    }

    if (category === 'Online Booking' || category === 'Seasonal Swap Over') {
      return (
        <div ClassName="mobilebg">
           <h2 style={{ color: '#a90707', textAlign: 'center', fontWeight: '700', margin: '0', paddingTop: '15px' }}>Online Booking</h2>
         <div className='content-divLength shop_wheel_section seasonal_swap_over'>
            <div style={{textAlign: 'center'}}>
              <div>
                {this.renderseasonal('Vehicle', category)}
            </div>
            <h2 style={{ color: '#ffffff', textAlign: 'center', fontWeight: '700', margin: '0', paddingTop: '5px' }}>Online Booking For Seasonal Swap Over</h2>
            <span style={{ color: '#ffffff', textAlign: 'center', fontWeight: '500', margin: '0', paddingTop: '0px' }}>For Other Services Please Contact Us</span>
            </div>
         </div>
        </div>
      );
    }

    if (category === 'reschedule') {
      return (
        <div ClassName="mobilebg">
           <h2 style={{ color: '#000', textAlign: 'center', fontWeight: '700', margin: '0', paddingTop: '15px' }}></h2>
          <div className='content-divLength shop_wheel_section seasonal_swap_over' style={{textAlign: 'center', backgroundColor: '#000000cc'}}>
              <div>
                <div>
                  <SeasonalSwapReschedule/>
                </div>
              </div>
          </div>
       </div>
      );
    }                                                                        

    return (
      <div className="content-divLength shop_wheel_section" >
        <div className="searchBy-contentTires">
          <div className="searchBy-contentTires__btnListContainer">
            <div className="shop_wheel_conetent">
              {category === 'Wheels' ?
                <div className="tires_container">
                  <h2 className="content-titleFont">SEARCH WHEELS BY:</h2>
                  <div className="tires_btn_container">
                    {this.renderCategorySearchOption('Brand', category)}
                    {this.renderCategorySearchOption('Size', category)}
                    {this.renderCategorySearchOption('Vehicle', category)}
                    {this.renderCategorySearchOptionsku('SKU', category)}
                  </div>
                </div> :
                category === 'Services' ?
                                  <div style={{ width: '100%' }}>
                                    <h2 className="content-titleFont">Loading Services ... </h2>
                                  </div> :

                  <div className="tires_container">
                    <h2 className="content-titleFont">SEARCH TIRES BY:</h2>
                    <div className="tires_btn_container">
                      {/* {this.renderCategorySearchOption('Brand', category)} */}
                      {this.renderCategorySearchOption('Size', category)}
                      {this.renderCategorySearchOption('Vehicle', category)}
                      {this.renderCategorySearchOptionsku('SKU', category)}
                    </div>
                  </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderCategorySearchOptionsku = (searchOption, category) => {
    return (
        <div className="searchBy-contentTires__btnContainer houman1">
          <button
            className="searchBy-contentTires__btnlist"
            style={{
              background: 'linear-gradient(135deg, #C50000 0%, #a00000 100%)',
              color: 'white',
              border: 'none',
              padding: '15px 30px',
              borderRadius: '3px',
              fontSize: '16px',
              fontWeight: '700',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              cursor: 'pointer',
              boxShadow: '0 4px 15px rgba(197, 0, 0, 0.3)',
              transition: 'all 0.3s ease',
              minWidth: '120px',
              minHeight: '50px'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(197, 0, 0, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(197, 0, 0, 0.3)';
            }}
            onClick={() => this.setState({ openModal: true })} >
            {searchOption}
          </button>
        </div>
    );
  }

  renderCategorySearchOption = (searchOption, category) => {
    const router = this.context.router;
    window.localStorage.setItem('category', category);
    window.localStorage.setItem('searchcategory', searchOption);
    if (searchOption !== 'Vehicle') {
      localStorage.removeItem('search_by');
      localStorage.removeItem('carModel');
      localStorage.removeItem('carMake');
      localStorage.removeItem('carYear');
    }

    return (
      <div className="searchBy-contentTires__btnContainer">
        <button
          className="searchBy-contentTires__btnlist"
          style={{
            background: 'linear-gradient(135deg, #C50000 0%, #a00000 100%)',
            color: 'white',
            border: 'none',
            padding: '15px 30px',
            borderRadius: '3px',
            fontSize: '16px',
            fontWeight: '700',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            cursor: 'pointer',
            boxShadow: '0 4px 15px rgba(197, 0, 0, 0.3)',
            transition: 'all 0.3s ease',
            minWidth: '120px',
            minHeight: '50px'
          }}
          onMouseOver={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(197, 0, 0, 0.4)';
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(197, 0, 0, 0.3)';
          }}
          onClick={() => router.push('/' + category.replace(/ /g, '%20') + '/' + searchOption)} >
          {searchOption}
        </button>
      </div>
    );
  }

  renderwinterpackage = (searchOption, category) => {
    window.localStorage.setItem('category', category);

    return (
      <div className="searchBy-contentTires__btnContainer">
      <WinterPackage/>
      </div>
    );
  }

  renderseasonal = (searchOption, category) => {
    window.localStorage.setItem('category', category);

    return (
      <div className="searchBy-contentTires__btnContainer">
      <SeosonalSwap/>
      </div>
    );
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  render() {
    const { category } = this.props.params;
    const { router } = this.context;

    if (!category) {
      console.error('SearchBy.js, we are not in a category, so go back to the homepage');
      router.push('/');
    }

    return (
        <div>
            <Modal
                  back={{
                    style: {
                      backgroundColor: 'rgba(0,0,0,0.3)',
                      boxShadow: 'none',
                      backdropFilter: 'blur(5px)'
                    }
                    }}
                    description="search"
                    onCloseModal={(e) =>
                      this.setState({
                        openModal: false
                    })}
                    openModal={this.state.openModal}
                  >
                <div style={{ 
                  width: '60%', 
                  maxWidth: '1200px', 
                  margin: 'auto', 
                  height: 'auto', 
                  display: 'flex', 
                  flexDirection: 'column', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                  borderRadius: '7px',
                  boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                  padding: '40px 20px',
                  position: 'relative',
                  border: '1px solid rgba(255, 255, 255, 0.2)'
                }}>
                  {/* Close Button */}
                  <button
                    onClick={() => this.setState({ openModal: false })}
                    style={{
                      position: 'absolute',
                      top: '15px',
                      right: '15px',
                      background: 'rgba(197, 0, 0, 0.1)',
                      border: 'none',
                      borderRadius: '50%',
                      width: '50px',
                      height: '50px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '28px',
                      color: '#C50000',
                      transition: 'all 0.3s ease',
                      fontWeight: '400'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.background = 'rgba(197, 0, 0, 0.2)';
                      e.target.style.transform = 'scale(1.1)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.background = 'rgba(197, 0, 0, 0.1)';
                      e.target.style.transform = 'scale(1)';
                    }}
                  >
                    ×
                  </button>

                  {/* Header with Icon */}
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    marginBottom: '30px',
                    textAlign: 'center'
                  }}>
                    <div style={{
                      background: 'linear-gradient(135deg, #C50000 0%, #a00000 100%)',
                      borderRadius: '20%',
                      width: '60px',
                      height: '60px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '20px',
                      boxShadow: '0 8px 25px rgba(197, 0, 0, 0.3)'
                    }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="white"
                        width="28px"
                        height="28px"
                      >
                        <path d="M2 4h2v16H2V4zm3 0h1v16H5V4zm2 0h1v16H7V4zm3 0h2v16h-2V4zm3 0h1v16h-1V4zm2 0h3v16h-3V4zm4 0h1v16h-1V4zm2 0h2v16h-2V4z"/>
                      </svg>
                    </div>
                    <h2 style={{ 
                      color: '#2c3e50', 
                      fontWeight: '700',
                      fontSize: '28px',
                      margin: '0',
                      background: 'linear-gradient(135deg, #C50000 0%, #a00000 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    }}>
                      SEARCH BY PART NUMBER (SKU)
                    </h2>
                  </div>

                  {/* Content */}
                  <div style={{ width: '100%' }}>
                    {this.props.params.category === 'Wheels' && <Searchsku/> }
                    {this.props.params.category === 'Tires' && <SearchskuTires/> }
                  </div>
                </div>
            </Modal>
       {this.getSearchOptionsForCategory(category)}
      </div>
    );
  }
}

SearchBy.propTypes = {
  params: React.PropTypes.object.isRequired
};

SearchBy.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default withRouter(SearchBy);



// WEBPACK FOOTER //
// ./src/components/SearchBy.js